import React from 'react';
import FlagsContext from '../../firebase/FlagsContext';
import { DefaultRemoteConfigFlags } from 'firebase/defaultRemoteConfigFlags';

export const useFlags = (): DefaultRemoteConfigFlags => {
  const context = React.useContext(FlagsContext);
  return context;
};
